export const AuthApi = {
  login: "login/auth",
  forgetPassword: "login/forgetPassword",
  resetPassword: "login/resetPassword",
  verifyOTP: "login/verifyOtp",
  changePassword: "user/changePassword",
};
